import { render, staticRenderFns } from "./PurchaseOrderItems.vue?vue&type=template&id=700f1ac8&"
import script from "./PurchaseOrderItems.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderItems.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports